import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import API from "../helpers/endpointservice";
import { useNavigate } from "react-router-dom";
import Actions from "../../action/api";
import { getParticularUser } from "../../action/UsersApi";

function Keyss(props) {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("isSessionExpiredTAC");
    firstFunction();
  }, []);

  const firstFunction = async () => {
    try {
      props.dispatch({ type: "BG_LOADER", data: true });
      const token = localStorage.getItem("AccessTokenTAC");
      let headers = { Authorization: `Bearer ${token}` };
      //   await axios.put(API.LAST_LOGIN, null, { headers });
      //   await axios.get(API.IsSSO, { headers });
      const [lastLoginRes, isSSORes] = await Promise.all([
        axios.put(API.LAST_LOGIN, null, { headers }),
        axios.get(API.IsSSO, { headers }),
      ]);

      // Extract TRUE/FALSE from isSSO API
      const isSSO = Boolean(isSSORes.data);

      // Save to localStorage
      // localStorage.setItem("isSSOConfigTAC", JSON.stringify(isSSO));

      if (
        JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole === "Admin"
      ) {
        navigate("/users");
        props.dispatch({ type: "BG_LOADER", data: false });
        // .catch( (er)=> {
        //
        //     if (er?.response?.status === 403) {
        //         window.location.href = '/unauthorize'; // Redirect if unauthorized
        //         console.log('HELLO');
        //         props.dispatch({ type: "BG_LOADER", data: false });
        //     }
        // })
      } else if (
        JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole === "User"
      ) {
        let userid = JSON.parse(localStorage.getItem("UserInfoTAC")).userId;
        props.dispatch(getParticularUser(userid)).then((res) => {
          props.dispatch({ type: "BG_LOADER", data: false });
          navigate("/homepage");
        });
        // .catch((err)=>{

        // })
      }
    } catch (er) {
      if (er?.response?.status === 403) {
        // window.location.href = '/unauthorize';
        navigate("/unauthorize");
      }
    }
  };
  return <div className="bgcwhite"></div>;
}

const mapStateToProps = (state) => {
  return {
    BG_LOADER: state.userReducer.BG_LOADER,
    BG_HOME_LOADER: state.userReducer.BG_HOME_LOADER,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Keyss);
